export const auth: stringObj = {
  checkTicket: 'auth/is_ticket'
}